import { html } from "lit";
var icon_creativeIntelligence_default = () => html`
  <svg stroke-fill viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
      <path
        d="M27.125 14a3.5 3.5 0 0 0-2.547-3.367 2.624 2.624 0 0 0-1.613-4.498 2.673 2.673 0 0 0-.48-.424 3.5 3.5 0 0 0-6.371-2.891 2.623 2.623 0 0 0-4.228 0 3.5 3.5 0 0 0-6.371 2.891 2.672 2.672 0 0 0-.48.423 2.624 2.624 0 0 0-1.613 4.5 3.5 3.5 0 0 0 0 6.734 2.623 2.623 0 0 0 1.613 4.498c.143.16.304.302.48.423a3.5 3.5 0 0 0 6.371 2.891 2.624 2.624 0 0 0 4.228 0 3.5 3.5 0 0 0 6.371-2.89 2.67 2.67 0 0 0 .48-.424 2.623 2.623 0 0 0 1.613-4.498A3.5 3.5 0 0 0 27.125 14Z" />
      <path d="M14 26.25V9.625" />
      <path d="M12.25 7.875a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z" />
      <path d="M10.5 21.875v-3.5l-2.625-1.75V14" />
      <path d="M6.125 12.25a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z" />
      <path d="M17.5 21.875v-3.5l2.625-1.75V14" />
      <path d="M18.375 12.25a1.75 1.75 0 1 0 3.5 0 1.75 1.75 0 0 0-3.5 0Z" />
    </g>
    <defs>
      <clipPath id="a"><path d="M0 0h28v28H0z" /></clipPath>
    </defs>
  </svg>
`;
export {
  icon_creativeIntelligence_default as default
};
//# sourceMappingURL=icon-creativeIntelligence.js.map
